module.exports = {
  localeName: 'ja-JP',
  momentFormat: 'YYYY/MM/DD'
};
